"use client";

import type React from "react";
import { type ChangeEvent } from "react";
import { Input } from "@/components/ui/input";

interface CpfCnpjInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const CpfCnpjInput: React.FC<CpfCnpjInputProps> = ({
  value,
  onChange,
  className,
}) => {
  const digits = value.replace(/\D/g, "").slice(0, 14);
  const isCpf = digits.length <= 11;

  const formattedValue = isCpf
    ? digits
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    : digits
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{1,2})$/, "$1-$2");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value.replace(/\D/g, "").slice(0, 14));
  };

  return (
    <Input
      value={formattedValue}
      onChange={handleChange}
      placeholder={isCpf ? "___.___.___-__" : "__.___.___/____-__"}
      type="text"
      className={className}
    />
  );
};
